import { Typography } from 'components/uikit/Typography/Typography'

import { ProjectsData } from './ProjectsData'
import styles from './ProjectsSubhead.module.scss'
import CircleArrows from '../../assets/images/projects/circle_arrows.gif'
import Ellipse from '../../assets/images/projects/ellipse.svg'
import Bubble from '../common/bubble/Bubble'
import { Flex } from '../common/flex/Flex'

const title = 'Types of Experience Loop Briefs'
const bubbleText = "What's your type?"

const ProjectsSubhead = () => {
  return (
    <div className={styles.container}>
      <div className={styles.headerContainer}>
        <div className={styles.imageContainer}>
          <img src={CircleArrows} alt="" />
        </div>
        <div className={styles.titleWrapper}>
          <h2 className={styles.title}>{title}</h2>
          <Bubble text={bubbleText} color="#E4FF3C" className={styles.bubble} direction="up" />
        </div>
      </div>
      <Flex gapCol={96} gapRow={72} wrap="wrap" className={styles.contentContainer}>
        {ProjectsData.map(project => {
          return (
            <Flex gap={24} className={styles.cardContainer} key={project.title}>
              <div className={styles.projectImageContainer}>
                <img src={project.img} alt="" />
              </div>
              <Flex gap={32} direction="column" className={styles.textWrapper}>
                <div className={styles.titleContainer}>
                  <Typography tag="h3" type="2xl-heading" className={styles.cardTitle} color="#400103">
                    {project.title}
                  </Typography>
                </div>
                <div className={styles.textContainer}>
                  <p className={styles.cardText}>{project.description}</p>
                </div>
              </Flex>
            </Flex>
          )
        })}
        <div className={styles.ellipseContainer}>
          <img src={Ellipse} alt="" />
        </div>
      </Flex>
    </div>
  )
}

export default ProjectsSubhead
